<template src="./footer.html">
    
</template>
<script>
export default {

    data(){
        return{
            names:["james", "john","Ladis"],
            year:''
        }
    },

    mounted(){
        let date = new Date;
        this.year = date.getFullYear();
    }    

    
}
</script>




// WEBPACK FOOTER //
// src/components/layout/footer/footer.vue